export default {
  system: {
    user: 'Người dùng',
    level: 'Cấp độ',
    earnPerTap: 'Thu nhập mỗi lần chạm',
    coinsToLevelUp: 'Số xu để lên cấp',
    profitPerHour: 'Lợi nhuận mỗi giờ',
    coming1: 'Điều thú vị',
    coming2: 'sắp xuất hiện ở đây....',
    close: 'Đóng',
    friends: 'Bạn bè',
    continue: 'Tiếp tục',
  },
  settings: {
    chooseNetwork: 'Chọn mạng',
    chooseLanguage: 'Chọn ngôn ngữ',
  },
  popup_CheckTask: {
    join: 'Tham gia',
    check: 'Kiểm tra',
    taskIsNotCompleted: 'Nhiệm vụ chưa hoàn thành',
  },
  popup_levelUp: {
    levelUp: 'Lên cấp!',
    multiTap: 'Chạm nhiều lần',
    energyLimit: 'Giới hạn năng lượng',
  },
  popup_BalanceUp: {
    balanceUp: 'Cập nhật số dư!',
    balanceDiffSinceLast: 'Phần thưởng của bạn',
  },
  popup_BalanceTip: {
    tip: 'Tăng lợi nhuận của bạn',
    message: 'Nhấn vào menu Đào để mua nâng cấp cho mạng của bạn',
    description: 'Kiếm tiền ngay cả khi không trực tuyến trong tối đa 3 giờ',
  },
  popup_Bored: {
    header: 'Ếch đang chán!',
    message: 'Chơi với ếch.',
    description: 'Nếu không chơi với ếch trong 3 giờ, lợi nhuận sẽ dừng lại',
  },
  popup_Hungry: {
    header: 'Ếch đang đói!',
    message: 'Cho ếch ăn.',
    description: 'Càng nhiều bạn bè, mỗi lần cho ăn càng mang lại nhiều xu',
  },
  menu: {
    network: 'Mạng',
    mine: 'Đào',
    earn: 'Kiếm tiền',
    food: 'Thức ăn',
  },
  tap: {
    bored: 'Chán',
    fun: 'Vui',
  },
  mineMenu: {
    activities: 'Hoạt động',
    investments: 'Đầu tư',
    web3: 'WEB3',
    achievements: 'Thành tựu',
  },
  leaderboard: {
    from: 'từ',
    beTheFirst: 'Hãy là người đầu tiên!',
  },
  mine: {
    joinOurTG1: 'Tham gia kênh Telegram của chúng tôi,',
    joinOurTG2: 'để mở khóa!',
    unlock: 'Mở khóa',
  },
  friends: {
    inviteFriends: 'Mời bạn bè!',
    receiveBonuses: 'Bạn và bạn của bạn sẽ nhận được tiền thưởng',
    inviteFriend: 'Mời một người bạn',
    withTelegramPremium: 'với Telegram Premium',
    forYouAndYourFriend: 'cho bạn và bạn của bạn',
    moreBonuses: 'Thêm tiền thưởng',
    listOfYourFriends: 'Danh sách bạn bè của bạn',
    linkCopied: 'Liên kết mời đã được sao chép vào bộ nhớ tạm!',
    playWithMe:
      'Tham gia cùng tôi và chơi để kiếm token thông qua airdrop!\n' +
      '💰 Nhận quà của bạn! +3000 xu cho người mới\n' +
      '🚀 Bạn có Telegram Premium? Nhận +5000 xu!\n',
  },
  earn: {
    moreCoins: 'Kiếm thêm xu!',
    dailyTasks: 'Nhiệm vụ hàng ngày',
    dailyReward: 'Phần thưởng hàng ngày',
    tasksList: 'Danh sách nhiệm vụ',
    joinOurTG: 'Tham gia kênh Telegram của chúng tôi',
    followOurX: 'Theo dõi tài khoản X của chúng tôi',
    yourAd: 'Quảng cáo của bạn có thể ở đây',
    connect: 'Liên hệ với quản trị viên kênh Telegram của chúng tôi',
  },
  food: {
    hungry: 'Đói',
    full: 'No',
    frogIsFull: 'Ếch đã no',
    feed: 'Cho ăn',
    bonus: 'Tiền thưởng',
    satiety: 'Độ no',
    hours: 'giờ',
  },
  toast: {
    buyCard: {
      title: 'Đã mở khóa thành tích!',
      subtitle: 'Đã đến lúc dẫn dắt đế chế ếch của bạn đến sự vĩ đại 👑',
    },
    feedFrog: {
      title: 'Chú ếch đang vui!',
      subtitle: 'Làm tốt lắm! Hãy cho thú cưng ăn để giữ nụ cười 🍽️',
    },
  },
};
